document.addEventListener('alpine:init', () => {
    Alpine.store('bundle', {
        steps: 0,
        activeStep: Alpine.$persist(0).as('Bundle_activeStep'),
        scentType: Alpine.$persist(null).as('Bundle_scentType'),
        bundleType: {
            text: Alpine.$persist(null).as('Bundle_bundleType_text'),
            size: Alpine.$persist(null).as('Bundle_bundleType_size'),
            info: Alpine.$persist(null).as('Bundle_bundleType_info')
        },
        products: {
            limit: Alpine.$persist(2).as('Bundle_products_limit'),
            list: Alpine.$persist([]).as('Bundle_products_list')
        },
        subscription: {
            months: Alpine.$persist(1).as('Bundle_subscription_months'),
            text: Alpine.$persist(null).as('Bundle_subscription_text'),
            info: Alpine.$persist(null).as('Bundle_subscription_info'),
        },
        diffuserPopup: false,
        diffuser: {
            title: null,
            src: null,
            price: null,
            variant_id: null,
        },
        bundlePresets: null,
        loading: false,
        deluxeCandleCount: 0,
        init() {
            const bundlePresets = document.getElementById('bundle_presets').innerHTML;
            this.bundlePresets = JSON.parse(bundlePresets);
        },
        handleBundle(bundleType, size, info) {
            this.bundleType = {
                text: bundleType,
                size: parseInt(size),
                info: info
            };
            this.products.limit = parseInt(size);
            this.products.list = [];
        },
        handleScentType(scentType) {
            this.scentType = scentType;
            this.products.list = [];
        },
        isCollectionActive(collection) {
            return collection?.toLowerCase() === this.scentType?.toLowerCase();
        },
        placeholderCount() {
            return this.products.limit - this.products.list.length
        },
        addProduct(e) {
            if(this.products.limit === this.products.list.length) {
                alert("Maximum product limit reached!");
                return;
            }

            const currentDeluxeCandleCount = this.products.list.filter(product => product.tags.some(t => t === 'deluxe candle')).length;
            const tags = e.target.dataset.productTags.split(',');
            if (tags.some(t => t === 'deluxe candle') && currentDeluxeCandleCount > 1) {
                alert("You can only add one deluxe candle to your bundle!");
                return;
            }
            
            this.products.list.push({
                title: e.target.dataset.title,
                image: e.target.dataset.image,
                price: Number(e.target.dataset.price),
                variant_id: Number(e.target.dataset.variantId),
                available_quantity: Number(e.target.dataset.avaialableQauntity),
                collection_id: Number(e.target.dataset.collectionId),
                product_id: Number(e.target.dataset.productId),
                tags: tags,
            })
        },
        isProductAdded(variant_id) {
            return this.products.list.some(p => p.variant_id === variant_id);
        },
        getProductQuantity(variant_id) {
            return this.products.list.filter(p => p.variant_id === variant_id).length;
        },
        increaseProduct(variant_id, tags) {
            console.log(tags)
            const currentDeluxeCandleCount = this.products.list.filter(product => product.tags.some(t => t === 'deluxe candle')).length;
            if (tags.split(',').some(t => t === 'deluxe candle') && currentDeluxeCandleCount > 0) {
                alert("You can only add one deluxe candle to your bundle!");
                return;
            }

            if(this.products.limit === this.products.list.length) {
                alert("Maximum product limit reached!");
                return;
            }
            this.products.list.push(this.products.list.find(p => p.variant_id === variant_id));
        },
        decreaseProduct(variant_id) {
            console.log("decreased")
            let prodArr = this.products.list;
            for (let i = 0; i < prodArr.length; i++) {
                console.log(i)
                if (prodArr[i].variant_id === variant_id) {
                    prodArr.splice(i, 1)
                    break;
                }
            }
            this.products.list = [...prodArr];
        },
        handleSubscription(text, months, info) {
            this.subscription = {
                text,
                months,
                info
            }
        },
        getSubtotal() {
            const bundleDetails = this.bundlePresets.find(b => b.size === parseInt(this.bundleType.size) && b.months === parseInt(this.subscription.months));
            return `$${(parseInt(bundleDetails?.price || 0 )/100).toFixed(2)}`
        },
        getFilteredProducts() {
            let sortedProducts = [];
            console.log(this.products.list)
            for(const product of this.products.list) {
                const pushedProduct = sortedProducts.find(p => p.variant_id === product.variant_id);
                if (!pushedProduct) {
                    sortedProducts.push({...product, quantity: 1});
                    continue;
                }
                sortedProducts = [
                    ...sortedProducts.filter(p => p.variant_id !== product.variant_id),
                    {
                        ...pushedProduct,
                        quantity: pushedProduct.quantity + 1
                    }
                ];
            }
            return sortedProducts;
        },
        async checkout() {
            try {
                // this.loading = true;
                const selectedProducts = this.getFilteredProducts();
                
                await fetch('/cart/clear.js');

                // recharge.init({
                //     // this should be your myshopifyUrl
                //     storeIdentifier: 'hotelcollection.myshopify.com'
                // });
                console.log(this.bundleType.size, this.subscription.months, this.bundlePresets)
                const bundleDetails = this.bundlePresets.find(b => b.size === parseInt(this.bundleType.size) && b.months === parseInt(this.subscription.months));
                console.log("Bundle Details => ", bundleDetails);

                if (!bundleDetails?.product_id) {
                    throw new Error("Bundle product not found! Maybe the bundle preset is not configured properly or the products are set to draft.");
                }
                
                // const bundleSettings = await recharge.cdn.getCDNBundleSettings(bundleDetails.product_id);

                // const selection = {
                //     "externalVariantId": bundleSettings.variants[0].external_variant_id,
                //     "externalProductId": bundleSettings.external_product_id,
                //     "selections": selectedProducts?.map(p => {
                //         return {
                //             "collectionId": p.collection_id,
                //             "externalVariantId": p.variant_id,
                //             "externalProductId": p.product_id,
                //             "quantity": p.quantity
                //         }
                //     })
                // }

                // console.log(recharge.bundle);

                // const _rb_id = await recharge.bundle.getBundleId(selection, {});

                const data = {
                    items: [{
                        id: bundleDetails.variant_id,
                        quantity: 1,
                        selling_plan: bundleDetails.selling_plan_id,
                        properties: {
                            // _rb_id, // this is the only require attribute - which links the bundle to this particular line item
                            Contents: selectedProducts.map(p => `${p?.quantity}X ${p?.title}`).join(', ')
                        },
                    }]
                };

                await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                this.clear();
                window.location.href = '/checkout';

            } catch (error) {
                // this.loading(false)
                console.log(error);
            }
        },
        clear() {
            const storageKeys = [
                "Bundle_activeStep",
                "Bundle_scentType",
                "Bundle_bundleType_text",
                "Bundle_bundleType_size",
                "Bundle_bundleType_info",
                "Bundle_products_limit",
                "Bundle_products_list",
                "Bundle_subscription_months",
                "Bundle_subscription_text",
                "Bundle_subscription_info"
            ]

            for(const key of storageKeys) {
                localStorage.removeItem(key);
            }
            // this.activeStep = 0;
            // this.scentType = null;
            // this.bundleType = {
            //     text: null,
            //     size: null,
            //     info: null
            // };
            // this.products = {
            //     limit: 2,
            //     list: []
            // };
            // this.subscription = {
            //     months: 1,
            //     text: null,
            //     info: null,
            // }
        },
        addDiffuser() {
            this.diffuser = {
                title: 'Studio Scent Diffuser',
                image: 'https://cdn.shopify.com/s/files/1/0399/6457/3862/products/BlackMini_cd874e87-9dc6-49a0-92e1-82284983510e.png?v=1659115747&_accept=image/avif',
                price: '299.95',
                variant_id: 45581363380390
            }
        },
        removeDiffuser() {
            this.diffuser = {
                title: null,
                image: null,
                price: null,
                variant_id: null
            }
        },
        estimatedDelivery() {
            const today = new Date();
            const deliveryDate = new Date(today);
            deliveryDate.setMonth(today.getMonth() + 1);
            return deliveryDate.toDateString();
        },
        planExpiryDate() {
            const today = new Date();
            const expiryDate = new Date(today);
            expiryDate.setMonth(today.getMonth() + parseInt(this.subscription.months));
            return expiryDate.toDateString();
        },
        discountedAmount() {
            const subtotal = this.products.list.reduce((a, product) => a + product.price, 0);
            const bundleDetails = this.bundlePresets.find(b => b.size === parseInt(this.bundleType.size) && b.months === parseInt(this.subscription.months));
            return `$${(((subtotal * parseInt(this.subscription.months)) - bundleDetails.price)/100).toFixed(2)}`
        },
        discountedPercentage() {
            const subtotal = this.products.list.reduce((a, product) => a + product.price, 0);
            const bundleDetails = this.bundlePresets.find(b => b.size === parseInt(this.bundleType.size) && b.months === parseInt(this.subscription.months));
            return `${Math.round(((subtotal - bundleDetails.price)/subtotal) * 100)}%`
        },
        splittedAmount() {
            const bundleDetails = this.bundlePresets.find(b => b.size === parseInt(this.bundleType.size) && b.months === parseInt(this.subscription.months));
            return `$${((bundleDetails.price / bundleDetails.months)/100).toFixed(2)}`
        }
    })
});
